export default __webpack_public_path__ + "static/media/contact2.0869db52.png";